import { render, staticRenderFns } from "./CreateOrderLayout.vue?vue&type=template&id=dc2e66a6"
import script from "./CreateOrderLayout.vue?vue&type=script&lang=js"
export * from "./CreateOrderLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports